<style lang="scss" scoped>
$padding: 60px;
.text-banner {
    position: relative;
    width: 100%;
    height: auto;
    height: 400px;
    max-width: 2040px;
    margin: 0 auto;

    h1 {
        font-size: 32px;
        font-weight: 600;
        line-height: 1.2;
        max-width: 560px;

        @media screen and (min-width: 1024px) {
            font-size: 64px;
            line-height: 64px;
        }
    }

    img {
        position: absolute;
        width: 100%;
        height: 100%;
        object-fit: cover;
        font-family: "object-fit: cover;";
    }

    .content-wrapper {
        &:after {
            content: "";
            z-index: 1;
            top: 0;
            left: 0;
            position: absolute;
            width: 100%;
            height: 100%;
            border-radius: 4px;
            background-image: linear-gradient(
                45deg,
                rgba(0, 0, 0, 0.5) 0%,
                rgba(0, 0, 0, 0) 100%
            );
        }
    }

    .content {
        position: relative;
        line-height: 1;
        z-index: 2;
        padding-bottom: 32px;

        @media screen and (min-width: 1024px) {
            padding-bottom: 60px;
        }
    }

    @media screen and (min-width: 1440px) {
        padding: 0 $padding;
        height: 560px;
    }
}

.no-top-offset {
    .text-banner {
        padding-top: 0;
    }
}

.share {
    background-color: var(--accent);
    position: relative;
    z-index: 2;
    line-height: 1;

    span {
        font-size: 1rem;
    }

    .whatsapp {
        &:before {
            content: url("/svg/whatsapp-circle.svg");
        }
    }

    .linkedin {
        &:before {
            content: url("/svg/linkedin-circle.svg");
        }
    }

    .facebook {
        &:before {
            content: url("/svg/facebook-circle.svg");
        }
    }

    .email {
        &:before {
            content: url("/svg/email-circle.svg");
        }
    }

    .messenger {
        &:before {
            content: url("/svg/messenger-circle.svg");
        }
    }

    @media screen and (min-width: 1024px) {
        text-align: right;
        background-color: transparent;

        > div {
            position: absolute;
            bottom: 60px;
            left: 50%;
            transform: translateX(-50%);
        }
    }

    @media screen and (min-width: 1440px) {
        padding: 0 $padding;
    }
}
</style>

<template>
    <div class="row">
        <div class="col-12">
            <div class="text-banner">
                <div class="content-wrapper h-100 position-relative">
                    <img :src="story.acf.image.url" :alt="story.title.rendered">
                    <div class="content container h-100 d-flex justify-content-end flex-column">
                        <h1 class="text-white" v-html="story.title.rendered"></h1>
                        <div class="d-block mt-16">
                            <span class="text-white">{{ story.acf.author }}</span><span class="text-white font-weight-light">&nbsp;-&nbsp;{{ story.acf.participants }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="share w-100 py-16 py-lg-0">
                <div class="container">
                    <div class="d-md-flex align-items-center d-lg-block">
                        <span class="text-white font-weight-bold mr-md-16 mr-lg-0">Deel deze story</span>
                        <div class="mt-8 mt-md-0 mt-lg-8 d-md-inline-block d-lg-block">
                            <a target="_blank" :href="`https://www.linkedin.com/shareArticle?mini=true&url=${url}&title=${story.title.rendered}`" class="linkedin mr-8"></a>
                            <a target="_blank" :href="`https://www.facebook.com/sharer/sharer.php?u=${url}`" class="facebook mr-8"></a>
                            <a :href="`mailto:?subject=${story.title.rendered} - ToffeTeambuildings.be&amp;body=Lees hier de story: ${url}`" class="email mr-8"></a>
                            <a :href="`whatsapp://send?text=${url}`" class="whatsapp mr-8 mr-lg-0"></a>
                            <a :href="`fb-messenger://share/?link=${url}&app_id=123456789`" class="messenger d-lg-none"></a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "pagePart.story-page-hero",

    props: {
        story: {
            type: Object,
            required: false,
        },
    },

    computed: {
        url() {
            return window.location.href;
        }
    }
}
</script>